import styles from "../../Styles/NoteBody.module.css";

const NoteBody = ({ children }) => {
  return (
    <div className={styles.text_body}>
      <p className={styles.text_body__text}>{children}</p>
    </div>
  );
};
export default NoteBody;
